import axiosInstance from ".";

export const getServices = () => {
  return axiosInstance.get("/services");
};

export const addServices = (data) => {
  return axiosInstance.post("/services", data);
};

export const updateServices = (data) => {
    const { id, ...payload } = data;
    return axiosInstance.put(`/services/${id}`, payload);
  };